import PaymentFailed from './PaymentFailed'

export default PaymentFailed
